import { render, staticRenderFns } from "./AuthColumnConfig.vue?vue&type=template&id=7812e443&"
import script from "./AuthColumnConfig.vue?vue&type=script&lang=js&"
export * from "./AuthColumnConfig.vue?vue&type=script&lang=js&"
import style0 from "./AuthColumnConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports